import script from "./CampaignsDynamicTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignsDynamicTable.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignsDynamicTable.vue?vue&type=style&index=0&id=57bb884d&scoped=true&lang=css"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bb884d"]])

export default __exports__